export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1024,
  xl: 1536,
}

export type BreakpointType = keyof typeof breakpoints
